import {TextSemiBold} from '@hm/fundamental'
import {useLayoutEffect, useState, type RefObject} from 'react'
import {createPortal} from 'react-dom'

import {formatNumber} from '../../helpers'
import {useRiskSurveyTranslation} from '../../hooks'

type RiaSummaryRowProps = {
  totalLePrior?: number | null
  totalLeAfter?: number | null
  totalLeDelta?: number | null
  isFiltered?: boolean
  tableContainerRef?: RefObject<HTMLElement | null>
}

export const RiaSummaryRow = ({
  totalLePrior,
  totalLeAfter,
  totalLeDelta,
  isFiltered = false,
  tableContainerRef
}: RiaSummaryRowProps) => {
  const {t, i18n} = useRiskSurveyTranslation()
  const [tableEl, setTableEl] = useState<HTMLTableElement | null>(null)

  useLayoutEffect(() => {
    const el = tableContainerRef?.current?.querySelector('table') ?? null
    setTableEl(el)
  }, [tableContainerRef])

  const cells = (
    <>
      <td colSpan={5} className="py-3 px-4">
        <TextSemiBold>{isFiltered ? t('table.subtotal') : t('table.total')}</TextSemiBold>
      </td>
      <td className="py-3 px-4">
        <TextSemiBold>{formatNumber(totalLePrior, i18n.language)}</TextSemiBold>
      </td>
      <td className="py-3 px-4">
        <TextSemiBold>{formatNumber(totalLeAfter, i18n.language)}</TextSemiBold>
      </td>
      <td className="py-3 px-4">
        <TextSemiBold>{formatNumber(totalLeDelta, i18n.language)}</TextSemiBold>
      </td>
      <td colSpan={2} />
    </>
  )

  if (tableEl) {
    return createPortal(
      <tfoot className="border-t-2 border-gray-300" data-cy="ria-summary-row">
        <tr>{cells}</tr>
      </tfoot>,
      tableEl
    )
  }

  // Fallback for tests / SSR where no table element is available
  return (
    <table data-cy="ria-summary-row">
      <tfoot className="border-t-2 border-gray-300">
        <tr>{cells}</tr>
      </tfoot>
    </table>
  )
}
